<template>
  <MtxPage width="md" v-if="submission">
    <template #header>
      <h1>{{ submission.title }}</h1>
      <h3>{{ (submission.timestamp * 1000) | date("MMM Do, YYYY") }}</h3>
    </template>

    <div class="grid submission__info-panels grid-gap">
      <MtxCard>
        <h5>Created by</h5>
        <p class="ml-2 mb-4">
          <ProfileLink :address="submission.owner" />
        </p>

        <h5>Submitted to</h5>
        <p class="ml-2">
          Tournament
          <RouterLink
            :to="{
              name: 'TournamentsSingle',
              params: { tournamentAddress: submission.tournament }
            }"
          >
            {{ submission.tournament | ethAddress }}
          </RouterLink>
        </p>
      </MtxCard>

      <MtxCard>
        <h5>Description</h5>
        <p class="ml-2 mb-4 pre-wrap">{{ submission.description }}</p>

        <h5>Submission Content</h5>
        <p class="ml-2">
          Commit
          <RouterLink :to="`/commits/${submission.commit.hash}`">
            {{ submission.commit.hash | commitHash }}
          </RouterLink>
          <br />
          <a
            :href="`https://ipfs.infura.io/ipfs/${submission.commit.ipfsContent}/`"
            target="_blank"
          >
            View Files on IPFS
          </a>
        </p>
      </MtxCard>
    </div>
  </MtxPage>
</template>

<script>
import nprogress from "@/mixins/nprogress"
import API from "@/api"

export default {
  mixins: [nprogress],

  props: {
    submissionHash: {
      type: String,
      required: true
    }
  },

  data: () => ({
    submission: null
  }),

  metaInfo() {
    return {
      titleTemplate: this.submission ? `%s | ${this.submission.title}` : "%s",
      meta: [
        {
          name: "description",
          content: this.submission
            ? `${this.submission.description}`
            : "A submission on the Matryx platform."
        }
      ]
    }
  },

  watch: {
    submissionHash: {
      handler: "getSubmission",
      immediate: true
    }
  },

  methods: {
    async getSubmission() {
      this.submission = null
      this.isLoading = true

      const { success, data } = await API.getSubmission(this.submissionHash)
      if (success) {
        this.submission = data.submission
      }

      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
.submission {
  &__info-panels {
    @include breakpoint(sm) {
      grid-template-columns: 1fr 2fr;
    }
  }
}
</style>
